/**
 * Controller: EntitiesListRemoveModal
 */
angular.module('acme.view.application.entities.list.removeModal.controllers', [
  'acme.common.service.helpers'
])
.controller('EntitiesListRemoveModalController', [ '$scope', '$uibModalInstance', 'HelpersService', 'entity', 'entityType', function ($scope, $uibModalInstance, HelpersService, entity, entityType) {

    $scope.errors = [];

    $scope.model = {
      name: entity.name,
      type: entityType.singular,
      label: HelpersService.cap(entityType.displaySingular)
    };

    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);